import Vue from 'vue'
import App from './App'
import router from './router'
// 引入axios，并加到原型链中
import axios from 'axios'
import "./assets/common.css";
import store from './store'
import QS from 'qs'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import { ShareImpl } from "@/utils/weixinApi.js";
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
Vue.use(MintUI)
Vue.prototype.qs = QS;
Vue.config.productionTip = false
import {isWexinmobile,toast} from './utils/utils.js'
Vue.filter('timeType', function (time) {
  var date=new Date(time*1000);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
    var nowDate = year + "-" + month + "-" + day;
  return nowDate
})
Vue.prototype.$toast = toast;
Vue.prototype.$wxShare = ShareImpl;
Vue.prototype.baseURl="http://wap.zglcyy.com/api/home/"//原型中加入baseURl 不可删除 用于pdf
new Vue({
  el: '#app',
  router,
  axios,
  store,
  created() {
    if(localStorage.getItem('iniUrl')){

    }else{
      let url=window.location.href
      localStorage.setItem('iniUrl',url)
    }
    
    if(!isWexinmobile()){
    }
  },
  components: { App },
  render: h => h(App)
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
      document.title=to.meta.title  
  }
  const token = localStorage.getItem('token')  
  const loginStus = localStorage.getItem('loginStus')
  if (token&&token.length>0) {
    if(loginStus=='true'){
      next()
    }else{
      if(to.path=='/login'||to.name=='transfer'||to.name=='bindTel'){
        next();
      } else {
        if(isWexinmobile()){
          next('/transfer');
        }else{
          next('/login');
        }

          
      }
    }
  } else { 
      if(to.path=='/login'||to.name=='transfer'||to.name=='bindTel'){
        next();
      } else {
        if(isWexinmobile()){
          next('/transfer');
        }else{
          next('/login');
        }

          
      }

  }
  // next();
});

var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?9b21840c7123b64069e6ab64959f5daf";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();





// WEBPACK FOOTER //
// ./src/main.js